export enum PermissionsList {
  //Customer360
  view_customer360_customer_details_card = 'view_customer360_customer_details_card',
  view_customer360_customer_raise_a_repair = 'view_customer360_customer_raise_a_repair',
  view_customer360_asset_raise_a_repair = 'view_customer360_asset_raise_a_repair',
  view_customer360_wo_raise_a_repair = 'view_customer360_wo_raise_a_repair',
  view_customer360_multi_account_summary_card = 'view_customer360_multi_account_summary_card',
  view_customer360_rent_account_summary_card = 'view_customer360_rent_account_summary_card',
  view_customer360_customer_dob = 'view_customer360_customer_dob',
  view_customer360_caution_alerts_banner = 'view_customer360_caution_alerts_banner',
  view_customer360_property_alerts_banner = 'view_customer360_property_alerts_banner',
  view_customer360_accounts_full_view_list = 'view_customer360_accounts_full_view_list',
  view_customer360_rent_account_only_view_account = 'view_customer360_rent_account_only_view_account',
  view_customer360_rent_account_only_summary_card = 'view_customer360_rent_account_only_summary_card',
  view_customer360_customer_UCC_Card = 'view_customer360_customer_UCC_Card',
  create_customer360_customer_UCC_arrearsaction = 'create_customer360_customer_UCC_arrearsaction',
  view_customer360_keydetails_card = 'view_customer360_keydetails_card',
  customer360_view_rent_account_card = 'customer360_view_rent_account_card',
  customer360_view_tenency_details_card = 'customer360_view_tenency_details_card',
  customer360_view_rent_details_card = 'customer360_view_rent_details_card',
  view_asset360_cases_search_for_case = 'view_asset360_cases_search_for_case',

  //Asset360
  view_asset360_asset_property_details_card = 'view_asset360_asset_property_details_card',
  view_asset360_asset_divided_block_details_card = 'view_asset360_asset_divided_block_details_card',
  view_asset360_asset_block_details_card = 'view_asset360_asset_block_details_card',
  view_asset360_asset_estate_details_card = 'view_asset360_asset_estate_details_card',
  view_asset360_cases_summary_card = 'view_asset360_cases_summary_card',
  view_asset360_customer_summary_card = 'view_asset360_customer_summary_card',
  view_asset360_key_contacts_summary_card = 'view_asset360_key_contacts_summary_card',
  view_asset360_caution_alerts_banner = 'view_asset360_caution_alerts_banner',
  create_asset360_block_sms = 'create_asset360_block_sms',
  create_customer360_financial_inclusion_referral = 'create_customer360_financial_inclusion_referral',

  view_asset360_asset_estate_raise_a_repair = 'view_asset360_asset_estate_raise_a_repair',
  create_asset360_asset_estate_raise_a_case = 'create_asset360_asset_estate_raise_a_case',
  view_asset360_asset_estate_raise_a_case = 'view_asset360_asset_estate_raise_a_case',
  view_asset360_asset_estate_address = 'view_asset360_asset_estate_address',
  view_asset360_asset_estate_uprn = 'view_asset360_asset_estate_uprn',
  view_asset360_asset_estate_local_authority = 'view_asset360_asset_estate_local_authority',
  view_asset360_asset_estate_asbestos_status = 'view_asset360_asset_estate_asbestos_status',
  view_asset360_asset_estate_maintenance_responsibility = 'view_asset360_asset_estate_maintenance_responsibility',
  view_asset360_asset_estate_heating_type = 'view_asset360_asset_estate_heating_type',
  view_asset360_asset_block_heating_type = 'view_asset360_asset_block_heating_type',
  view_asset360_asset_block_maintenance_responsibility = 'view_asset360_asset_block_maintenance_responsibility',
  view_asset360_asset_block_asbestos_status = 'view_asset360_asset_block_asbestos_status',
  view_asset360_asset_block_asset_status = 'view_asset360_asset_block_asset_status',

  //WorkOrder360
  view_workorder360_key_contacts_summary_card = 'view_workorder360_key_contacts_summary_card',
  view_asset360_property_alerts_banner = "view_asset360_property_alerts_banner",
  view_workorder360_property_alerts_banner = "view_workorder360_property_alerts_banner",
  view_workorder360_caution_alerts_banner = "view_workorder360_caution_alerts_banner",
  //Create enhanced hub reapir journey
  workorder_override_duplicate_repairs = "override_duplicate_repairs",
  workorder_no_triage_forheatingandhotwaterrepairs = "no_triage_forheatingandhotwaterrepairs",
  workorder_choose_priority_of_repair = "choose_priority_of_repair",
  workorder_view_ADHESIVE_prompt_additional_details = "view_ADHESIVE_prompt_additional_details",
  view_contractor_OOH_communication_instruction = "view_contractor_OOH_communication_instruction",
  workoder_vulnerable_hide_permission = "hide_vulnerable_page",
  workorder_review_triage_repair = "review_triage_repair",
  update_digital_journey_hhsrs_hazard_repair = "update_digital_journey_hhsrs_hazard_repair",


  //Digital Journey
  view_digital_journey_appoint_a_repair = 'view_digital_journey_appoint_a_repair',
  view_digital_journey_recall_a_repair = 'view_digital_journey_recall_a_repair',

  //Create Surveys
  create_p360_surveying1 = 'create_p360_surveying1',
  view_p360_surveying1 = 'view_p360_surveying1',

  //CRM Open
  view_open_crm = 'view_open_crm',

  //Open vantage
  view_vantage_link = 'view_vantage_link',
  //View EDMS Link
  view_edms_link = 'view_edms_link',

  //Orbis Permissions 
  create_repair_standard = 'create_repair_standard',
  view_work_order_details_card = 'view_work_order_details_card',
  view_work_order_summary_card = 'view_work_order_summary_card',
  view_customer_profile_card = 'view_customer_profile_card',
  view_key_contacts_card = 'view_key_contacts_card',
  view_case_summary_card = 'view_case_summary_card',
  view_asset_summary_card = 'view_asset_summary_card',
  view_asset_details_card = 'view_asset_details_card',

  //View work order 360 view and case 360 view permission
  view_work_order_360_view = 'view_work_order_360_view',
  view_cases_360_views = 'view_cases_360_views',
  view_work_order_history = 'view_work_order_history',
  view_case_history = 'view_case_history',
  view_case_details_card = 'view_case_details_card',
  view_landing_page = 'view_landing_page',
  view_customer_360_view = 'view_customer_360_view',
  view_asset_360_view = 'view_asset_360_view',
  additional_needs_alerts_restricted = 'additional_needs_alerts_restricted',
  view_work_order_list = 'view_work_order_list',
  cases_list = 'cases_list',
  additional_needs_alerts_basic = 'additional_needs_alerts_basic',
  edit_customer_profile = 'edit_customer_profile',
  create_case_standard = 'create_case_standard',
  access_enhanced_repair_diagnostics_journey = 'access_enhanced_repair_diagnostics_journey',
  p360_advancedrepairs1 = 'p360_advancedrepairs1'
}